module.exports = __webpack_public_path__ + "static/media/temp-hero.c87fda5d.jpg";